import { createSlice, Slice as SliceInterface } from '@reduxjs/toolkit';

const RefundFormSlice: SliceInterface = createSlice({
  name: 'REFUND_FORM',
  initialState: {
    jsonSchema: {},
    uiSchema: {},
    extraErrors: {},
    loaded: false,
    error: false,
    errorExistDevolution: false,
    loadingRequest: false,
    dataMsgSchema: {},
  },
  reducers: {
    addRefundFormDataConfiguration(state, action){
      return { 
        ...action.payload,
        loaded: true,
      };
    },
    returnWithErrors(state, action){
      return {
          ...action.payload,
          loaded: true,
          error: true
      }
    },
    loadingRequest(state, action){
      return {
        ...action.payload,
        loadingRequest: true
      }
    },
    returnErrorExistDevolution(state, action){
      return {
          ...action.payload,
          loaded: true,
          error: true,
          errorExistDevolution: true
      }
    }
  }
});

export const {
  addRefundFormDataConfiguration,
  returnWithErrors,
  returnErrorExistDevolution,
  saveFormData
} = RefundFormSlice.actions;

export default RefundFormSlice;